import type { RootState } from '../../../store/rootReducer';

// Auth state selectors
export const selectAuth = (state: RootState) => state.auth;

export const selectUser = (state: RootState) => state.auth.user;

export const selectCurrentUser = (state: RootState) => state.auth.user;

export const selectIsAuthenticated = (state: RootState) => state.auth.isAuthenticated;

export const selectIsLoading = (state: RootState) => state.auth.isLoading;

export const selectError = (state: RootState) => state.auth.error;

export const selectNeedsOTP = (state: RootState) => state.auth.needsOTP;

export const selectGoogleDriveConnection = (state: RootState) => state.auth.googleDrive;

export const selectOTPEmail = (state: RootState) => state.auth.otpEmail;

// User role selectors
export const selectUserRole = (state: RootState) => state.auth.user?.role;

export const selectHasRole = (requiredRoles: string | string[]) => (state: RootState) => {
  const user = state.auth.user;
  if (!user) return false;

  const roles = Array.isArray(requiredRoles) ? requiredRoles : [requiredRoles];
  return roles.includes(user.role);
};

export const selectHasAdminAccess = (state: RootState) => {
  const user = state.auth.user;
  if (!user) return false;
  return user.role === 'admin' || user.role === 'super_admin';
};

export const selectCanPerformWrite = (state: RootState) => {
  const user = state.auth.user;
  if (!user) return false;
  return user.role === 'admin' || user.role === 'super_admin';
};
